import { ajustarEspaciadoMain } from "./utils.js";

const menuBtn = document.querySelector('.header__menu-boton');
const navBar = document.querySelector('.header__navbar');
const callToAction = document.querySelector('.header__navbar-calltoaction');

let isMenuVisible = false;

const showMenuMobile = ()=>{
    navBar.style.display = 'block';
    void navBar.offsetHeight;
    navBar.classList.add('header__navbar--visible');
    
    callToAction.classList.remove('header__navbar-calltoaction');
    callToAction.classList.add('header__navbar-link');

    isMenuVisible = true;
}

const hideMenuMobile = ()=>{
    navBar.classList.remove('header__navbar--visible');
    isMenuVisible = false;

    const handleTransitionEnd = (event) =>{
        if(event.propertyName === 'transform');
        navBar.removeEventListener('transitionend', handleTransitionEnd)
        navBar.style.display = 'none';
        navBar.removeAttribute('style');

        callToAction.classList.remove('header__navbar-link');
        callToAction.classList.add('header__navbar-calltoaction');    

        ajustarEspaciadoMain();
    }

    navBar.addEventListener('transitionend', handleTransitionEnd);
}

if(menuBtn){
    menuBtn.addEventListener('click', (e)=>{
        e.preventDefault();

        const icon = menuBtn.querySelector('i');
                
        if(!isMenuVisible){
            showMenuMobile();
            icon.classList.remove('fa-bars');
            icon.classList.add('fa-xmark');
        }else{
            hideMenuMobile();
            icon.classList.add('fa-bars');
            icon.classList.remove('fa-xmark');
        }
    })
}

document.addEventListener('click', (e) =>{
    if(isMenuVisible){
        // Y el click NO fue dentro del navBar Y el click NO fue en el menuBtn
        // Usamos .contains() para verificar si el elemento clickeado es un descendiente de navBar o menuBtn
        if(!navBar.contains(e.target) && !menuBtn.contains(e.target)){
            hideMenuMobile();

            const icon = menuBtn.querySelector('i');
            if (icon && icon.classList.contains('fa-xmark')) {
                icon.classList.remove('fa-xmark');
                icon.classList.add('fa-bars');
            }
        }
    }
})